import { render } from "./primeMenu.vue?vue&type=template&id=3ecb4ca0"
import script from "./primeMenu.vue?vue&type=script&lang=js"
export * from "./primeMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__